import { type ReactElement } from 'react';
import { type CenterLayoutProps } from '@/layout/types';
import { CenterLayoutLanguageSelector } from '@/shared/components/LanguageSelector';
import { cn } from '@/utils/tailwind.util';
export function getCenterLayout(page: ReactElement, showLanguageSelector = false) {
  return <CenterLayout showLanguageSelector={showLanguageSelector} data-sentry-element="CenterLayout" data-sentry-component="getCenterLayout" data-sentry-source-file="getCenterLayout.tsx">
      {page}
    </CenterLayout>;
}
export const CenterLayout = (props: CenterLayoutProps) => {
  const {
    className,
    children,
    showLanguageSelector = false,
    ...rest
  } = props;
  return <>
      {showLanguageSelector && <CenterLayoutLanguageSelector />}
      <div className={cn('pointer-events-auto p-md tablet-sm:p-2xl fixed z-10  flex h-dvh w-full flex-col items-center justify-center bg-neutral', className)} {...rest}>
        {children}
      </div>
    </>;
};